'use strict';

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);

/**
 * React hook, use to match media queries
 * @see https://fireship.io/snippets/use-media-query-hook/
 */
var useMatchMedia = function useMatchMedia(query) {
  var _useState = React.useState(false),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    matches = _useState2[0],
    setMatches = _useState2[1];
  React.useEffect(function () {
    var matchMedia = window.matchMedia;
    // fallback for usage in tests
    if (!matchMedia) {
      return;
    }
    var media = matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    var listener = function listener() {
      return setMatches(media.matches);
    };
    window.addEventListener('resize', listener);
    return function () {
      return window.removeEventListener('resize', listener);
    };
  }, [matches, query]);
  return matches;
};

exports.useMatchMedia = useMatchMedia;
//# sourceMappingURL=useMatchMedia-1f69f0f1.js.map
